import { Component } from "react"
import Top from "./Top"
import Bottom from "./Bottom"
import Connect from "./Connect"
import "./index.css"
import "./Connect.css"
import "./PageLayout.css"

class FacultyPage extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  }

  render() {
    return (
      <div>
        <Top />
        <div className="page-container">
          <div className="page-header">
            <h1 className="page-title">师资建设</h1>
            <p className="page-subtitle">介绍课程师资团队和教师在嵌入式系统领域的研究成果</p>
          </div>
          <Connect />
        </div>
        <Bottom />
      </div>
    )
  }
}

export default FacultyPage